// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { ModifyLimitOrder } from "../order-modify/ModifyLimitOrder.js"
import { OrderTypeBase } from "./OrderTypeBase.js";
import { OrderType } from "../../../../Utils/Trading/OrderType.js"
import { LimitOrderEdit } from "../order-edit/LimitOrderEdit.js";
export let LimitOrderType = function ()
{
    OrderTypeBase.call(this, LimitOrderEdit, ModifyLimitOrder)
}

LimitOrderType.prototype = Object.create(OrderTypeBase.prototype)

LimitOrderType.prototype.id = function ()
{
    return OrderType.Limit
}